export default {
	'the-planned-visit': 'الزيارة المخطط لها',
	'planned-visit': 'زيارة مخططة',
	all: 'الكل',
	'no-planned-visits-for-this-day': 'لا زيارات مخططة لهذا اليوم',
}